export default "<div [class]=\"move\">\r\n    <ng-content></ng-content>\r\n</div>"